import React from "react";

const MANDALA =
  "https://static.prod-images.emergentagent.com/jobs/a4b18afd-b735-452c-a88b-6aee2704ff09/images/375f61ff977ff0d3fa5fe5e3dd68aac80319d3fbdb2f2a06213313cac4d00c31.jpeg";

export const AboutSection = () => {
  return (
    <section id="about" className="relative overflow-hidden bg-gradient-to-b from-[#FAF6F0] to-[#F6ECDF] py-20 sm:py-24">
      <img src={MANDALA} alt="" className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 object-contain opacity-20 spin-slow mix-blend-multiply" />
      <img src={MANDALA} alt="" className="pointer-events-none absolute -left-28 bottom-0 h-80 w-80 object-contain opacity-15 spin-slow mix-blend-multiply" style={{ animationDirection: "reverse" }} />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="text-xs tracking-widest uppercase font-semibold text-amber-700">About Soulful Invites</span>
        <h2 className="mt-2 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950">
          The most beautiful invitations <span className="gold-text">you'll ever share</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-stone-700 leading-relaxed">
          From charming animated character figures to stunning image and video invitations, every design is
          crafted with elegant, eye-catching motion. Our collection spans <span className="font-semibold text-amber-900">every theme</span> —
          designed around your state, your religion and your traditions — so your invite feels truly yours.
          Every invitation is fully customisable with your names, dates and colours, at the most
          budget-friendly prices.
        </p>
      </div>
    </section>
  );
};
